module.exports = __webpack_public_path__ + "img/list-corner.84c91808.svg";